module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@2x-2717948b636774ce39d2582c100b271d.png";